import { getAPIEndpoint } from "../config";
import axios from "axios";

export async function logger(message) {
    try {
        await axios.post(getAPIEndpoint('error'), message);
    }
    catch (error) {
    }
}